import { useRouter } from 'next/router';

export const useTableFromQuery = () => {
  const router = useRouter();

  return router?.query?.table;
};
